import { useQuery } from "@tanstack/react-query";

import { JobRead } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";
import { objectValues } from "@nens/shared-utils";

import { useUpdateJobInListIfOutdated } from "./query-job";
import { useInvalidateFilesAndHistoryQueriesIfOutdated } from "./refetch-files-and-history";

// Single

export const useJobResultsQuery = (job?: JobRead) => {
  const invalidateFilesAndHistoryQueriesIfOutdated =
    useInvalidateFilesAndHistoryQueriesIfOutdated();
  const updateJobInListIfOutdated = useUpdateJobInListIfOutdated();
  return useQuery(
    getRanaApiV1().getQueryOptions({
      queryKey: ["process-results", job?.id, job?.state.type],
      queryFn: async () => {
        if (!job) throw Error("Never happens");
        const response = await getRanaApiV1().JobsApi.jobResults({ jobId: job.id });

        if (!job.finishedAt) return response;

        // Check if last files fetch was before the job finished
        objectValues(response).forEach((result: string | object | null) => {
          if (
            job.finishedAt &&
            result &&
            typeof result === "object" &&
            "id" in result &&
            "ref" in result
          ) {
            const id = result.id + "";

            // Refetch file
            invalidateFilesAndHistoryQueriesIfOutdated(job.finishedAt, id);
          }
        });

        updateJobInListIfOutdated(job.finishedAt, job);

        return response;
      },
      enabled: !!job && job.state.type === "completed",
    })
  );
};
